const KeyCodes = {
    ENTER: 13,
    ESCAPE: 27,
};

export default KeyCodes;


// WEBPACK FOOTER //
// src/utils/KeyCodes.js